// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /memories/events — full-width shell + responsive event cards */
.memories-events-page {
  --me-bg: #f6f4fb;
  --me-surface: #ffffff;
  --me-surface-muted: #f1f5f9;
  --me-text: #0f172a;
  --me-text-muted: #475569;
  --me-text-faint: #64748b;
  --me-border: #e2e8f0;
  --me-accent: #4f46e5;
  --me-page-pad: clamp(0.75rem, 2.5vw, 1.5rem);
  --me-card-radius: clamp(1rem, 2vw, 1.5rem);
}

html.dark .memories-events-page {
  --me-bg: #020617;
  --me-surface: #1e293b;
  --me-surface-muted: #334155;
  --me-text: #f1f5f9;
  --me-text-muted: #cbd5e1;
  --me-text-faint: #94a3b8;
  --me-border: #475569;
  --me-accent: #818cf8;
}

.memories-events-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100dvh - 4.25rem);
  min-height: calc(100vh - 4.25rem);
  background: linear-gradient(
    165deg,
    var(--me-bg) 0%,
    color-mix(in srgb, var(--me-bg) 70%, #ffffff) 45%,
    color-mix(in srgb, var(--me-bg) 85%, #dbeafe) 100%
  );
  color: var(--me-text);
}

html.dark .memories-events-page {
  background: linear-gradient(165deg, var(--me-bg) 0%, #0f172a 50%, #1e1b4b 100%);
}

.memories-events-page .me-page-inner {
  width: 100%;
  max-width: 100%;
  margin-inline: auto;
  padding-inline: var(--me-page-pad);
  padding-bottom: clamp(1.5rem, 4vw, 3rem);
}

.memories-events-page .me-hero {
  width: 100%;
  margin-top: var(--me-page-pad);
  margin-bottom: clamp(0.75rem, 2vw, 1.25rem);
}

.memories-events-page .me-filter-panel,
.memories-events-page .me-state-card,
.memories-events-page .me-event-card {
  background-color: var(--me-surface);
  border-color: var(--me-border);
  color: var(--me-text);
}

.memories-events-page .me-event-card {
  width: 100%;
  max-width: none;
  min-width: 0;
  min-height: 100%;
  border-radius: var(--me-card-radius);
}

.memories-events-page .me-event-card .me-card-cover {
  aspect-ratio: 16 / 10;
  width: 100%;
  flex-shrink: 0;
}

@media (min-width: 640px) {
  .memories-events-page .me-event-card .me-card-cover {
    aspect-ratio: 5 / 3;
  }
}

.memories-events-page .me-event-card .me-card-body {
  padding: clamp(0.875rem, 2.5vw, 1.25rem);
}

.memories-events-page .me-event-card .me-card-body-muted {
  color: var(--me-text-muted);
}

.memories-events-page .me-event-card .me-card-meta {
  color: var(--me-text-faint);
}

.memories-events-page .me-event-card .me-card-meta strong {
  color: var(--me-text-muted);
}

.memories-events-page .me-group-heading {
  color: var(--me-text);
}

.memories-events-page .me-group-count {
  color: var(--me-text-faint);
}

/* Responsive card grid — cards always fill cell width */
.memories-events-page .me-events-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: clamp(0.875rem, 2.5vw, 1.25rem);
  width: 100%;
  align-items: stretch;
}

@media (min-width: 640px) {
  .memories-events-page .me-events-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .memories-events-page .me-events-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1536px) {
  .memories-events-page .me-events-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.memories-events-page .me-card-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.memories-events-page .me-card-actions .me-btn {
  min-height: 2.75rem;
  touch-action: manipulation;
}

@media (max-width: 639px) {
  .memories-events-page .me-card-actions .me-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.25rem);
    justify-content: center;
    min-width: 0;
  }
}

.memories-events-page .me-filter-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1fr);
}

@media (min-width: 640px) {
  .memories-events-page .me-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .memories-events-page .me-filter-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.memories-events-page .me-filter-grid input {
  min-height: 2.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/memories/memories-events-page.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kCAAkC;EAClC,iCAAiC;EACjC;;;;;GAKC;EACD,qBAAqB;AACvB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;;;EAGE,mCAAmC;EACnC,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* /memories/events — full-width shell + responsive event cards */\n.memories-events-page {\n  --me-bg: #f6f4fb;\n  --me-surface: #ffffff;\n  --me-surface-muted: #f1f5f9;\n  --me-text: #0f172a;\n  --me-text-muted: #475569;\n  --me-text-faint: #64748b;\n  --me-border: #e2e8f0;\n  --me-accent: #4f46e5;\n  --me-page-pad: clamp(0.75rem, 2.5vw, 1.5rem);\n  --me-card-radius: clamp(1rem, 2vw, 1.5rem);\n}\n\nhtml.dark .memories-events-page {\n  --me-bg: #020617;\n  --me-surface: #1e293b;\n  --me-surface-muted: #334155;\n  --me-text: #f1f5f9;\n  --me-text-muted: #cbd5e1;\n  --me-text-faint: #94a3b8;\n  --me-border: #475569;\n  --me-accent: #818cf8;\n}\n\n.memories-events-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: calc(100dvh - 4.25rem);\n  min-height: calc(100vh - 4.25rem);\n  background: linear-gradient(\n    165deg,\n    var(--me-bg) 0%,\n    color-mix(in srgb, var(--me-bg) 70%, #ffffff) 45%,\n    color-mix(in srgb, var(--me-bg) 85%, #dbeafe) 100%\n  );\n  color: var(--me-text);\n}\n\nhtml.dark .memories-events-page {\n  background: linear-gradient(165deg, var(--me-bg) 0%, #0f172a 50%, #1e1b4b 100%);\n}\n\n.memories-events-page .me-page-inner {\n  width: 100%;\n  max-width: 100%;\n  margin-inline: auto;\n  padding-inline: var(--me-page-pad);\n  padding-bottom: clamp(1.5rem, 4vw, 3rem);\n}\n\n.memories-events-page .me-hero {\n  width: 100%;\n  margin-top: var(--me-page-pad);\n  margin-bottom: clamp(0.75rem, 2vw, 1.25rem);\n}\n\n.memories-events-page .me-filter-panel,\n.memories-events-page .me-state-card,\n.memories-events-page .me-event-card {\n  background-color: var(--me-surface);\n  border-color: var(--me-border);\n  color: var(--me-text);\n}\n\n.memories-events-page .me-event-card {\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  min-height: 100%;\n  border-radius: var(--me-card-radius);\n}\n\n.memories-events-page .me-event-card .me-card-cover {\n  aspect-ratio: 16 / 10;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n@media (min-width: 640px) {\n  .memories-events-page .me-event-card .me-card-cover {\n    aspect-ratio: 5 / 3;\n  }\n}\n\n.memories-events-page .me-event-card .me-card-body {\n  padding: clamp(0.875rem, 2.5vw, 1.25rem);\n}\n\n.memories-events-page .me-event-card .me-card-body-muted {\n  color: var(--me-text-muted);\n}\n\n.memories-events-page .me-event-card .me-card-meta {\n  color: var(--me-text-faint);\n}\n\n.memories-events-page .me-event-card .me-card-meta strong {\n  color: var(--me-text-muted);\n}\n\n.memories-events-page .me-group-heading {\n  color: var(--me-text);\n}\n\n.memories-events-page .me-group-count {\n  color: var(--me-text-faint);\n}\n\n/* Responsive card grid — cards always fill cell width */\n.memories-events-page .me-events-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: clamp(0.875rem, 2.5vw, 1.25rem);\n  width: 100%;\n  align-items: stretch;\n}\n\n@media (min-width: 640px) {\n  .memories-events-page .me-events-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .memories-events-page .me-events-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1536px) {\n  .memories-events-page .me-events-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.memories-events-page .me-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.memories-events-page .me-card-actions .me-btn {\n  min-height: 2.75rem;\n  touch-action: manipulation;\n}\n\n@media (max-width: 639px) {\n  .memories-events-page .me-card-actions .me-btn {\n    flex: 1 1 calc(50% - 0.25rem);\n    justify-content: center;\n    min-width: 0;\n  }\n}\n\n.memories-events-page .me-filter-grid {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n@media (min-width: 640px) {\n  .memories-events-page .me-filter-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .memories-events-page .me-filter-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.memories-events-page .me-filter-grid input {\n  min-height: 2.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
